export const ifDefined = (value, action) => {
    if (typeof value !== "undefined") {
        action(value);
    }
};
